import FunctionSignatureChangeInterceptor from "./FunctionSignatureChangeInterceptor";
export default FunctionSignatureChangeInterceptor;